export const cdcFooterLinks = [
  ["U.S. Department of Health & Human Services", "https://www.hhs.gov/"],
  ["Accessibility", "https://www.cdc.gov/other/accessibility.html"],
  ["External Links", "https://www.cdc.gov/Other/disclaimer.html#exit-notification"],
  ["Privacy", "https://www.cdc.gov/other/privacy.html"],
  ["Policies", "https://www.cdc.gov/Other/policies.html"],
  ["No Fear Act", "https://www.cdc.gov/oeeowe/nofearact/"],
  ["FOIA", "https://www.cdc.gov/od/foia/"],
  ["Nondiscrimination", "https://www.cdc.gov/other/nondiscrimination.html"],
  ["OIG", "https://oig.hhs.gov/"],
  ["Vulnerability Disclosure", "https://www.hhs.gov/vulnerability-disclosure-policy/index.html"],
  ["USA.gov", "https://usa.gov/"]  
]

export const mobileAccordionMenuItems = [
  {
    id: 1,
    title: "Contact Us",
    content: [
      {text: "Contact Us", href: "https://www.cdc.gov/cdc-info/forms/contact-us.html"},
      {text: "Call 800-232-4636", href: "tel:800-232-4636"}
    ]
  },
  {
    id: 2,
    title: "About CDC",
    content: [
      {text: "About CDC", href: "https://www.cdc.gov/about/"},
      {text: "Pressroom", href: "https://jobs.cdc.gov/index.html"},
      {text: "Mission & Organization", href: "https://www.cdc.gov/about/organization/"},
      {text: "Budget & Funding", href: "https://www.cdc.gov/budget/"},
      {text: "Careers & Jobs", href: "https://jobs.cdc.gov/index.html"}
    ]
  },
  {
    id: 3,
    title: "Policies",
    content: [
      {text: "Accessibility", href: "https://www.cdc.gov/other/accessibility.html"},
      {text: "External Links", href: "https://www.cdc.gov/Other/disclaimer.html#exit-notification"},
      {text: "Privacy", href: "https://www.cdc.gov/other/privacy.html"},
      {text: "Web Policies", href: "https://www.cdc.gov/Other/policies.html"},
      {text: "FOIA", href: "https://www.cdc.gov/od/foia/"},
      {text: "OIG", href: "https://oig.hhs.gov/"},
      {text: "No Fear Act", href: "https://www.cdc.gov/oeeowe/nofearact/"},
      {text: "Nondiscrimination", href: "https://www.cdc.gov/other/nondiscrimination.html"},
      {text: "Vulnerability Disclosure Policy", href: "https://www.hhs.gov/vulnerability-disclosure-policy/index.html"}
    ]
  },
  {
    id: 4,
    title: "Archives",
    content: [
      {text: "CDC Archive", href: "https://archive.cdc.gov/"},
      {text: "Public Health Publications", href: "https://stacks.cdc.gov/"}
    ]
  },
]